<section class="bg-light p-3 p-md-4 p-xl-5">

    <!-- main container -->
    <div class="container d-flex justify-content-center align-items-center min-vh-100">

        <div class="row border bg-white box-shadow box-area mt-2 mb-2" style="width: 82%">

            <!-- left box -->
            <div class="col-md-6  bg-primary d-flex justify-content-center align-items-center flex-column left-box"
            >

                <div class="col-12 col-md-6">
                    <img class="img-fluid  w-100 h-100 object-fit-cover" src="assets/illustrators/reset-password-illustrator/reset-password.svg" alt="">
                </div>
            </div>

            <!-- right box -->
            <div class="col-md-6 right-box ">
                <div class="row align-items-center">

                    <div class="header-text mt-3">
                        <h6 class="fw-bold">Reset Password</h6>
                    </div>

                    <form [formGroup]="ResetPasswordFormGroup" (ngSubmit)="resetSubmit()" >

                          <!-- new Password -->
                        <div class="col-md-6 input-field mb-2">
                            <div class="input-group"  [ngClass]="{'invalid-border':ResetPasswordFormGroup.controls.newPassword.touched && ResetPasswordFormGroup.controls.newPassword.invalid}">
                                <div class="form-floating" [ngClass]="{'is-invalid':ResetPasswordFormGroup.controls.newPassword.touched && ResetPasswordFormGroup.controls.newPassword.invalid}">
                                    <input formControlName="newPassword" [type]="password ? 'password' : 'text'"
                                        type="password" class="form-control border-end-0" id="passwordStrong"
                                        placeholder="Enter Password" />
                                    <label for="passwordStrong">Enter New Password</label>
                                </div>
                                <div class="input-group-text border-start-0 bg-white">
                                    <i style="display: inline" type="button" (click)="password = !password"
                                        [ngClass]="password ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                                </div>
                                <div class="invalid-feedback" *ngIf="
                                  ResetPasswordFormGroup.controls.newPassword.touched &&
                                  ResetPasswordFormGroup.controls.newPassword.invalid
                                ">
                                    <span *ngIf="ResetPasswordFormGroup.controls.newPassword.errors.required">This field is
                                        mandatory.</span>
                                    <span *ngIf="ResetPasswordFormGroup.controls.newPassword.errors.pattern">Password must be at
                                        least 8 characters long, contain at
                                        least one uppercase letter, one lowercase letter,</span>
                                </div>
                            </div>
                        </div>

                        <!-- Confirm Password -->
                        <div class="col-md-6 input-field">
                            <div class="input-group" [ngClass]="{'invalid-border':ResetPasswordFormGroup.controls.confirmPassword.touched && ResetPasswordFormGroup.controls.confirmPassword.invalid}">
                                <div class="form-floating" [ngClass]="ResetPasswordFormGroup.controls.confirmPassword.touched && ResetPasswordFormGroup.controls.confirmPassword.invalid? 'is-invalid': 'is-valid'">
                                    <input formControlName="confirmPassword"
                                        [type]="confirmPassword ? 'password' : 'text'" type="password"
                                        class="form-control border-end-0" id="ConfirmPasswordStrong"
                                        placeholder="Enter Password" 
                                    />
                                    <label for="ConfirmPasswordStrong">Confirm Password</label>
                                </div>

                                <div class="input-group-text border-start-0 bg-white">
                                    <i style="display: inline" type="button"
                                        (click)="confirmPassword = !confirmPassword" [ngClass]="
                                    confirmPassword ? 'fa fa-eye-slash' : 'fa fa-eye'
                                  "></i>
                                </div>

                                <div class="invalid-feedback" *ngIf="
                                  ResetPasswordFormGroup.controls.confirmPassword.touched &&
                                  ResetPasswordFormGroup.controls.confirmPassword.invalid
                                ">
                                    <span *ngIf="ResetPasswordFormGroup.controls.confirmPassword.errors.required">This field is mandatory.</span>
                                    <!-- <span *ngIf="ResetPasswordFormGroup.controls.confirmPassword.errors.pattern">This field is invalid.</span> -->
                                </div>

                                <div class="invalid-feedback">
                                    <span *ngIf=" validateSubmit() && ResetPasswordFormGroup.controls.confirmPassword.invalid">Password does not match</span>
                                </div>

                                <div class="valid-feedback" *ngIf="!validateSubmit() &&!ResetPasswordFormGroup.controls.confirmPassword.invalid">
                                    <span>Password matched</span>
                                </div>
                            </div>
                        </div>

                  

                        <!-- dynamic class added button--loading for loading state -->
                        <div class="col-md-12 mt-2">
                            <button type="submit" [ngClass]="{ 'button--loading': isLoading }" [disabled]="isLoading"
                                class="btn btn-primary button--loading w-100">
                                <span class="button--text">Reset Password</span>
                            </button>
                        </div>

                        <div class="col-md-12 mt-2 mb-2">
                            <button type="button" class="btn btn-secondary w-100" (click)="onReset()"
                                [disabled]="isLoading">
                                Reset
                            </button>
                        </div>
                    </form>
                    <div class="row">
                        <div class="col-12">
                          <div class="d-flex gap-4  justify-content-center mt-5 mb-5">
                            <a routerLink="/auth/login" class="link-secondary text-decoration-none">Login</a>
                            <a routerLink="/auth/signup" class="link-secondary text-decoration-none">Sign up</a>
                          </div>
                        </div>
                      </div>
                </div>
            </div>

        </div>
    </div>
</section>